import { Deserializable } from '../protocols/deserializable';
import { InvestmentInstructionSubmissionData } from './investment-instruction-submission-data';
import { InvestmentInstructionSubmissionAffectedAccount } from './investment-instruction-submission-affected-account';
import { AccountTypeIdEnum } from '../transactions/enum/account-type-id.enum';
import { AccountType } from '../transactions/account-type';

export class InvestmentInstructionSubmission implements Deserializable {
  public accountTypeId!: AccountTypeIdEnum;
  public accountType!: AccountType;
  public previous!: InvestmentInstructionSubmissionData;
  public new!: InvestmentInstructionSubmissionData;
  public affectedAccounts!: InvestmentInstructionSubmissionAffectedAccount[];

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;

    if (!!this.previous) {
      this.previous = Deserialize.instanceOf(InvestmentInstructionSubmissionData, this.previous);
    }

    if (!!this.new) {
      this.new = Deserialize.instanceOf(InvestmentInstructionSubmissionData, this.new);
    }

    if (!!this.affectedAccounts) {
      this.affectedAccounts = Deserialize.arrayOf(
        InvestmentInstructionSubmissionAffectedAccount,
        this.affectedAccounts
      );
    }

    if (this.accountType) {
      this.accountType = Deserialize?.instanceOf(AccountType, this.accountType);
    }
  }
}
